module.exports = __webpack_public_path__ + "img/icon-submit.8a52e187.png";